var beautify_html = require('js-beautify').html;
var ejs = require('ejs');
var version = '12.0.4';

function hasClass(element, className) {
    if (element && element.getAttribute) {
        var rx = new RegExp('\\b' + className + '\\b');
        return element && rx.test(element.getAttribute('class'));
    }
}

function addClass(element, className) {
    if (element && element.setAttribute && !hasClass(element, className)) {
        var cn = element.getAttribute('class');
        element.setAttribute('class', cn ? cn + ' ' + className : className);
    }
}

function removeClass(element, className) {
    if (element && element.setAttribute && hasClass(element, className)) {
        var rx = new RegExp('\\s?\\b' + className + '\\b', 'g');
        var cn = element.getAttribute('class');
        element.setAttribute('class', cn.replace(rx, ''));
    }
}

function toggleClass(element, className) {
    if (hasClass(element, className)) {
        removeClass(element, className);
    } else {
        addClass(element, className);
    }
}

function mergeTemplate(template, properties) {
    return template.replace(/\{\{(\w+)(?:\:(\d+))?\}\}/g, function (_, key, indent) {
        var value = properties[key];

        if (indent) {
            value = indentCode(value, indent);
        }

        return value == undefined ? '' : value;
    });
}

var defaultReferences = {
    scripts: [
        'js/jquery-1.8.2.min.js',
        'js/spread/gc.spread.sheets.all.' + version + '.min.js'
    ],
    links: [
        'css/spread/gc.spread.sheets.excel2013white.' + version + '.css'
    ]
};


function generateIframePage(renderParts, forDemoPage, includeKey, resource) {
    var nn = "\<div class = \"dfdf\"\>"
    return generateIframePageHtmlAndReference(renderParts, forDemoPage, includeKey, resource, true)
}

function generateIframePageHtmlAndReference(renderParts, forDemoPage, includeKey, resource, isAllHtmlString) {
    var commonCss = renderParts.reference ?  '' : '*{-webkit-tap-highlight-color: rgba(0,0,0,0);}\n';
    if(renderParts.reference && renderParts.reference.indexOf('xx.x.x') >= 0) {
        renderParts.reference = renderParts.reference.replace('xx.x.x.css', 'excel2013white.' + version + '.css');
        renderParts.reference = renderParts.reference.replace(/xx.x.x/g, version);
    } else if(!renderParts.reference) {
        var links = defaultReferences.links;
        var scripts = defaultReferences.scripts;
        var dependencies = renderParts.dependencies;
        if(renderParts.dependencies) {
            scripts = scripts.concat((dependencies && dependencies.reference && dependencies.reference.scripts) || []);
            links = links.concat((dependencies && dependencies.reference && dependencies.reference.links) || []);
        }
        var reference = '', tempReference = '';
        links.forEach(function (link) {
            reference += '\t\t<link rel="stylesheet" type="text/css" href="' + link + '">\n';
        });
        scripts.forEach(function (script) {
            if(script.indexOf("gc.spread.sheets.resources.zh") >= 0) {
                tempReference += '\t\t<script src="js/spread/resources/zh/gc.spread.sheets.resources.zh.' + version + '.min.js" type="text/javascript"></script>\n';
            } else if (script.indexOf("gc.spread.sheets.resources.ja") >= 0) {
                tempReference += '\t\t<script src="js/spread/resources/ja/gc.spread.sheets.resources.ja.' + version + '.min.js" type="text/javascript"></script>\n';
            } else if (script.indexOf("gc.spread.sheets.resources.ko") >= 0) {
                tempReference += '\t\t<script src="js/spread/resources/ko/gc.spread.sheets.resources.ko.' + version + '.min.js" type="text/javascript"></script>\n';
            } else if (script.indexOf("gc.spread.excelio") >= 0) {
                tempReference += '\t\t<script src="js/spread/plugins/gc.spread.excelio.' + version + '.min.js" type="text/javascript"></script>\n';
            } else if (script.indexOf("gc.spread.sheets.print") >= 0) {
                tempReference += '\t\t<script src="js/spread/plugins/gc.spread.sheets.print.' + version + '.min.js" type="text/javascript"></script>\n';
            } else if (script.indexOf("gc.spread.sheets.pdf") >= 0) {
                tempReference += '\t\t<script src="js/spread/plugins/gc.spread.sheets.pdf.' + version + '.min.js" type="text/javascript"></script>\n';
            } else if (script.indexOf("gc.spread.sheets.charts") >= 0) {
                tempReference += '\t\t<script src="js/spread/plugins/gc.spread.sheets.charts.' + version + '.min.js" type="text/javascript"></script>\n';
            } else if (script.indexOf("gc.spread.sheets.barcode") >= 0) {
                tempReference += '\t\t<script src="js/spread/plugins/gc.spread.sheets.barcode.' + version + '.min.js" type="text/javascript"></script>\n';
            } else if (script.indexOf("gc.spread.sheets.shapes") >= 0) {
                tempReference += '\t\t<script src="js/spread/plugins/gc.spread.sheets.shapes.' + version + '.min.js" type="text/javascript"></script>\n';
            } else {
                reference += '\t\t<script src="' + script + '" type="text/javascript"></script>\n';
            }
        });
        renderParts.reference = reference;
    }
    if (tempReference !== undefined) {
        renderParts.reference += tempReference;
    }

    var dataFiles = (dependencies && dependencies.dataFiles) || [];
    var dataFileStr = '';
    dataFiles.forEach(function (dataFile) {
        dataFileStr += '\t\t<script src="data/' + dataFile + '" type="text/javascript"></script>\n';
    });

    renderParts.dataFileStr = dataFileStr;
    if ("debug" === process.env.NODE_ENV) {
        renderParts.reference = renderParts.reference.replace(/zepto\.js/g, 'zepto.min.js');
        renderParts.reference = renderParts.reference.replace(/lodash\.js/g, 'lodash.min.js');
        renderParts.reference = renderParts.reference.replace(/lodash\.min\.js\//g, 'lodash.js/');
        renderParts.reference = renderParts.reference.replace(/jquery\.js/g, 'jquery.min.js');
        renderParts.reference = renderParts.reference.replace(/globalize\.js/g, 'globalize.min.js');
        renderParts.reference = renderParts.reference.replace(/jsrender\.js/g, 'jsrender.min.js');
        renderParts.reference = renderParts.reference.replace(/ej\.web\.all\.js/g, 'ej.web.all.min.js');
        renderParts.reference = renderParts.reference.replace(/jquery\.js/g, 'jquery.min.js');
        renderParts.reference = renderParts.reference.replace(/modernizr\.js/g, 'modernizr.min.js');
        renderParts.reference = renderParts.reference.replace(/jquery-ui\.js/g, 'jquery-ui.min.js');

        renderParts.inlineScript = renderParts.inlineScript.replace(/\/\/spread\.grapecity\.com\/remotedata\/api/g, "//spread.cloudapp.net:8081/api");
    }

    if(renderParts.reference.indexOf('<script src="js/spread/license.js" type="text/javascript"></script>') < 0) {
        renderParts.reference += '\t\t<script src="js/spread/license.js" type="text/javascript"></script>\n';
    }

    if (forDemoPage) {
        renderParts.reference = renderParts.reference.replace(/<script src="js\//g, '<script src="../js/');
        renderParts.reference = renderParts.reference.replace(/href="css\//g, 'href="../css/');
        renderParts.inlineScript = renderParts.inlineScript.replace(/\.getJSON\(\'data\//g, ".getJSON('../data/");

        renderParts.inlineScript = renderParts.inlineScript.replace(/images\//g, "../images/");

        renderParts.inlineScript = renderParts.inlineScript.replace(/css\/\..\/images\//g, "../css/images/");
    }

    var htmlBody = renderParts.htmlBody || '<div id="grid1" style="height:100%"></div>';
    if (resource) {
        htmlBody = ejs.render(htmlBody, resource);
        htmlBody = ejs.render(htmlBody, resource);
    }

    if( htmlBody.indexOf("\<div class=\"options-container\"\>") > 0) {
        htmlBody = adaptMobileDevHtml(htmlBody);
        commonCss = adaptMobileDevCss(commonCss);
        renderParts.inlineScript += "$(\"\[data-click=toggle\]\").on('click', function(e) {\n" +
            "var $target = $(e.currentTarget).parent();\n" +
            "$target.toggleClass(\"hidden\");\n" +
            "});\n"
    }

    var bodyStyle = renderParts.htmlBodyStyle;
    //var inserScript = process.env.ADDKEYCOMMENTS ? '//Please provide valid license key. \r\n //GC.Spread.Views.LicenseKey ="Your Key";\r\n' : '';

    let htmlString = beautify_html('<!doctype html>' +
        '<html  style="height:100%;font-size:14px;">' +
        '<head>' +
        '<meta name="spreadjs culture" content="ko-kr" />' +
        '<meta charset="utf-8" />' +
        '<meta name="viewport" content="width=device-width, initial-scale=1.0" />' +
        renderParts.reference +
        renderParts.dataFileStr +
        (renderParts.inlineStyle ? ('<style>' + commonCss + '\n' + renderParts.inlineStyle + '</style>') : commonCss ? '<style>' + commonCss + '</style>' : '' ) +
        '</head>' +
        '<body ' + (bodyStyle ? bodyStyle : '') + '>' +
        htmlBody +
        (renderParts.template ? renderParts.template : '') +
        '<script type="text/javascript">' +
        //inserScript +
        renderParts.inlineScript +
        '</script>' +
        '</body>' +
        '</html>');
    if(isAllHtmlString){
        return htmlString;
    }else{
        return {
            htmlString:htmlString,
            reference:beautify_html(renderParts.reference+renderParts.dataFileStr)
        }
    }
}

function adaptMobileDevHtml(htmlBody) {
    let settingButton = "\<div class=\"sample-options\"\>\r\n" +
        "\<div class=\"options-toggle\" role=\"button\" data-click=\"toggle\"\>\r\n" +
        "\<svg fill=\"currentColor\" height=\"18\" viewBox=\"0 0 24 24\" width=\"18\" xmlns=\"http://www.w3.org/2000/svg\">\r\n" +
        "\<path d=\"M19.43 12.98c.04-.32.07-.64.07-.98s-.03-.66-.07-.98l2.11-1.65c.19-.15.24-.42.12-.64l-2-3.46c-.12-.22-.39-.3-.61-.22l-2.49 1c-.52-.4-1.08-.73-1.69-.98l-.38-2.65C14.46 2.18 14.25 2 14 2h-4c-.25 0-.46.18-.49.42l-.38 2.65c-.61.25-1.17.59-1.69.98l-2.49-1c-.23-.09-.49 0-.61.22l-2 3.46c-.13.22-.07.49.12.64l2.11 1.65c-.04.32-.07.65-.07.98s.03.66.07.98l-2.11 1.65c-.19.15-.24.42-.12.64l2 3.46c.12.22.39.3.61.22l2.49-1c.52.4 1.08.73 1.69.98l.38 2.65c.03.24.24.42.49.42h4c.25 0 .46-.18.49-.42l.38-2.65c.61-.25 1.17-.59 1.69-.98l2.49 1c.23.09.49 0 .61-.22l2-3.46c.12-.22.07-.49-.12-.64l-2.11-1.65zM12 15.5c-1.93 0-3.5-1.57-3.5-3.5s1.57-3.5 3.5-3.5 3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5z\"/\>\r\n" +
        "\</svg\>\r\n" +
        "\</div\>\r\n";
    htmlBody = htmlBody.replace("\<div class=\"options-container\"\>", settingButton + "\r\n" + "\<div class=\"options-container\"\>");
    htmlBody += "\</div\>";
    return htmlBody;
}

function adaptMobileDevCss(commonCss) {
    commonCss += ".sample-options {float: right;height: 100%;}\n" +
        ".options-toggle {display: none;}\n";
    let mobileCss = "@media only screen and (max-width: 768px) {\n" +
        ".options-toggle {display: block !important;top: 20px;left: -30px;width: 30px;height: 30px;position: absolute;background-color: #86bd00;line-height: 30px;text-align: center;padding: 4px;box-sizing: border-box;color: #fff;}\n" +
        ".options-container {width: 280px !important;overflow: auto;height: 100%;padding: 22px;box-sizing: border-box;}\n" +
        ".sample-spreadsheets {width: 100% !important;height: 100%;overflow: hidden;float: left;}\n" +
        ".sample-options {right: 0;padding: 0 !important;overflow: visible !important; position: absolute;box-shadow: 0 0 3px 0 rgba(0, 0, 0, .25);transition: right .25s ease-in-out;z-index: 1000;}\n" +
        ".sample-options.hidden {right: -280px;}\n" +
        "}\n";
    commonCss += mobileCss;
    return commonCss;
}

function getHtmlString(renderParts, reference, adaptMobileDev) {
    let commonCss = renderParts.reference ?  '' : '*{-webkit-tap-highlight-color: rgba(0,0,0,0);}\n';
    let htmlBody = renderParts.htmlBody || '<div id="grid1" style="height:100%"></div>';
    let bodyStyle = renderParts.htmlBodyStyle;
    let dataFileStr = renderParts.dataFileStr  || '';
    if(htmlBody.indexOf("\<div class=\"options-container\"\>") > 0 && adaptMobileDev) {
        htmlBody = adaptMobileDevHtml(htmlBody);
        commonCss = adaptMobileDevCss(commonCss);
        renderParts.inlineScript += "$(\"\[data-click=toggle\]\").on('click', function(e) {\n" +
            "var $target = $(e.currentTarget).parent();\n" +
            "$target.toggleClass(\"hidden\");\n" +
            "});\n"
    }

    return beautify_html('<!doctype html>' +
        '<html  style="height:100%;font-size:14px;">' +
        '<head>' +
        '<meta name="spreadjs culture" content="ko-kr" />' +
        '<meta charset="utf-8" />' +
        '<meta name="viewport" content="width=device-width, initial-scale=1.0" />' +
        reference +
        dataFileStr +
        (renderParts.inlineStyle ? ('<style>' + commonCss + '\n' + renderParts.inlineStyle + '</style>') : commonCss ? '<style>' + commonCss + '</style>' : '' ) +
        '</head>' +
        '<body ' + (bodyStyle ? bodyStyle : '') + '>' +
        htmlBody +
        (renderParts.template ? renderParts.template : '') +
        '<script type="text/javascript">' +
        //inserScript +
        renderParts.inlineScript +
        '</script>' +
        '</body>' +
        '</html>');
}

module.exports = {
    addClass: addClass,
    removeClass: removeClass,
    hasClass: hasClass,
    toggleClass: toggleClass,
    generateIframePage: generateIframePage,
    generateIframePageHtmlAndReference:generateIframePageHtmlAndReference,
    getHtmlString:getHtmlString,
    version: version
};


// WEBPACK FOOTER //
// ./client/utils/domUtils.js